import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { LayoutThumb } from "@/components/LayoutPicker";

export const LayoutsCard = () => {
  const [all, setAll] = useState([]);
  const [enabled, setEnabled] = useState([]);
  useEffect(() => { api.get("/layouts").then((r) => { setAll(r.data.layouts); setEnabled(r.data.enabled); }); }, []);

  const toggle = (id) => setEnabled((e) => (e.includes(id) ? (e.length > 1 ? e.filter((x) => x !== id) : e) : [...e, id]));
  const save = async () => {
    try {
      const { data: brand } = await api.get("/settings");
      await api.put("/settings", { ...brand, layouts_enabled: all.map((l) => l.id).filter((id) => enabled.includes(id)), layouts_known: all.map((l) => l.id) });
      toast.success("Layout options saved");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="bg-[var(--cream)] page-shadow p-8 lg:col-span-2" data-testid="layouts-card">
      <p className="text-[11px] tracking-[0.3em] uppercase text-[var(--muted-ink)]">Image page</p>
      <h2 className="text-base md:text-lg font-bold mt-1">Catalog layouts</h2>
      <p className="text-sm text-[var(--muted-ink)] mt-2 mb-6">Tick the layouts you want to offer. Each catalog picks one in “Edit pages”, and every product's image page in that catalog uses it.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {all.map((l) => (
          <label key={l.id} className={`cursor-pointer p-2 border-2 transition-colors ${enabled.includes(l.id) ? "border-[var(--ink)]" : "border-[var(--line)] opacity-60"}`} data-testid={`layout-setting-${l.id}`}>
            <LayoutThumb layout={l} />
            <span className="flex items-start gap-2 mt-2">
              <Checkbox checked={enabled.includes(l.id)} onCheckedChange={() => toggle(l.id)} data-testid={`layout-enable-${l.id}`} />
              <span><span className="block text-xs font-semibold">{l.name}</span><span className="block text-[11px] text-[var(--muted-ink)]">{l.description}</span></span>
            </span>
          </label>
        ))}
      </div>
      <Button onClick={save} className="mt-6" data-testid="save-layouts-button">Save layout options</Button>
    </section>
  );
};
